import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Solutions from "./pages/Solutions";
import Industries from "./pages/Industries";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Quality from "./pages/Quality";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import Admin from "./pages/Admin";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <div className="min-h-screen bg-white">
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/products/:slug" element={<ProductDetail />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/quality" element={<Quality />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/get-a-quote" element={<Quote />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="top-right" />
            </div>
        </BrowserRouter>
    );
}

export default App;
